import React, { useEffect, useState } from "react";
import { backend, blogurl, producturl } from "../../../../path";
import LoaderMain from "../../../layout/header/loader_sub";
import { Rating } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

function Page2(props) {
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );


  useEffect(() => {
    // Scroll to the top of the page whenever a new page is rendered
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);

    fetch(backend + `getproductgroup2`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleAddCart = async (id) => {
    if (authenticated === null) {
      navigate(`/login`);
      return;
    }

    const formData = {
      status: 1,
      quantity: 1,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setCartChange(!props.cartChange)
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the cart", {

          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
      }
    } catch (error) {
    }
  };

  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
    // window.location.reload();
  };
  const handleAddToWishList = async (id) => {
    if (authenticated === null) {
      navigate(`/login`);
      return;
    }

    const formData = {
      status: 0,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtowishlistuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setWishChange(!props.wishChange)
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the wishlist", {

          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
      }
    } catch (error) {

    }
  };
  return (
    <>
      <main className="main" id="main-section">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl pt-8 pb-16">
          {/* Visual Hero Banner */}
          <div 
            className="relative w-full overflow-hidden text-left mb-10 rounded-3xl flex flex-col md:flex-row items-stretch"
            style={{
              background: "linear-gradient(135deg, #2D1F18 0%, #1a120e 100%)",
              border: "1px solid rgba(197, 168, 128, 0.15)"
            }}
          >
            {/* Ambient light patterns */}
            <div className="absolute inset-0 pointer-events-none opacity-10 bg-[radial-gradient(#C5A880_1px,transparent_1px)] [background-size:16px_16px]" />
            <div className="absolute -left-24 -bottom-24 w-96 h-96 rounded-full bg-[#2D1F18]/40 filter blur-3xl pointer-events-none" />
            
            {/* Left Content (Text) */}
            <div className="w-full md:w-[60%] relative z-10 flex flex-col justify-center py-12 px-6 sm:px-12 md:px-16 lg:py-20">
              {/* Floating breadcrumbs */}
              <div className="inline-flex self-start items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-xs font-medium text-white/80 mb-6 font-jost">
                <a href="/" className="hover:text-white transition-colors text-white">Home</a>
                <span className="text-[#C5A880]/60">/</span>
                <span className="text-[#C5A880]">Featured Finds</span>
              </div>
              
              <span className="block text-[#C5A880] font-jost text-xs sm:text-sm font-semibold tracking-widest uppercase mb-2">
                Today's Curated Picks
              </span>
              <h1 className="text-white font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-4">
                Today's Featured Finds
              </h1>
              <div className="h-0.5 w-20 bg-[#C5A880] mb-6"></div>
              <p className="text-white/80 font-jost text-sm sm:text-base leading-relaxed max-w-xl text-justify mb-0">
                Embrace the excitement of discovery with our daily showcase of handpicked gems. Explore an ever-changing array of unique products, each carefully selected to delight and inspire.
              </p>
            </div>

            {/* Right Column – Full-Height Filled Image Showcase */}
            <div 
              className="hidden md:block md:w-[40%] relative overflow-hidden select-none flex-shrink-0"
              style={{
                clipPath: "polygon(12% 0, 100% 0, 100% 100%, 0% 100%)"
              }}
            >
              <img 
                src="/storage/category/featured_plain.png" 
                alt="Featured Finds" 
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#2D1F18]/10 pointer-events-none" />
              <div className="absolute inset-y-0 left-0 w-24 pointer-events-none bg-gradient-to-r from-[#2D1F18] to-transparent" />
            </div>
          </div>
          <div className="mb-16 mt-12 pb-12">
            {loading ? (
              <LoaderMain />
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 gap-y-12 text-left">
                {data.map((item, i) => {
                  const salePrice = Number(item?.sale_price) || Number(item?.mrp) || 0;
                  const mrp = Number(item?.mrp) || 0;
                  const staggerClass = i % 3 === 1 ? "lg:translate-y-6" : i % 3 === 2 ? "lg:translate-y-12" : "";
                  
                  return (
                    <div 
                      key={i}
                      className={`group relative bg-[#FAF8F5] border border-[#C5A880]/20 rounded-3xl p-5 shadow-[0_4px_25px_rgba(45,31,24,0.02)] hover:shadow-[0_16px_45px_rgba(45,31,24,0.08)] hover:border-[#C5A880]/60 -translate-y-0 hover:-translate-y-1.5 transition-all duration-500 flex flex-col justify-between overflow-hidden min-h-[380px] ${staggerClass}`}
                    >
                      <div>
                        {/* Media Box */}
                        <div className="relative aspect-square w-full rounded-2xl overflow-hidden mb-4 select-none bg-white border border-[#C5A880]/10 p-4 flex items-center justify-center">
                          <img
                            src={producturl + item?.thumbnail}
                            alt={item?.product_name}
                            onClick={() => handleProductRoute(item.product_slug)}
                            className="max-h-full max-w-full object-contain cursor-pointer transition-transform duration-700 ease-out group-hover:scale-105"
                          />
                          
                          {/* Masterpiece Stamp Badge */}
                          <span className="absolute top-3 left-3 bg-[#2D1F18] border border-[#C5A880]/40 text-[#C5A880] text-[9px] font-bold px-2.5 py-0.5 rounded shadow-md tracking-widest uppercase">
                            Masterpiece
                          </span>
                        </div>

                        {/* Category Row */}
                        <div className="flex items-center justify-between gap-2 mb-1.5">
                          <span className="text-[#C5A880] text-[10px] font-semibold tracking-widest uppercase">
                            {item?.brand || "HANDCRAFTED"}
                          </span>
                          <span className="text-[#2D1F18]/40 text-[10px] font-jost">
                            {item?.category_name}
                          </span>
                        </div>

                        {/* Product Title */}
                        <h3 
                          onClick={() => handleProductRoute(item.product_slug)}
                          className="font-playfair font-bold text-base text-[#2D1F18] mb-2 hover:text-[#C5A880] cursor-pointer line-clamp-2 transition-colors leading-tight"
                          title={item?.product_name}
                        >
                          {item?.product_name}
                        </h3>

                        {/* Ratings */}
                        <div className="flex items-center gap-1.5 mb-4">
                          <div className="flex items-center">
                            {Array.from({ length: 5 }).map((_, idx) => (
                              <svg 
                                key={idx} 
                                className={`w-3 h-3 ${idx < Math.round(Number(item.average_stars) || 4.5) ? 'text-amber-500 fill-current' : 'text-gray-200 fill-current'}`} 
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                              </svg>
                            ))}
                          </div>
                          <span className="text-[10px] font-jost text-[#2D1F18]/50">({item?.comments?.length || "8"} reviews)</span>
                        </div>
                      </div>

                      {/* Card Footer actions */}
                      <div>
                        <div className="h-px bg-[#C5A880]/15 w-full mb-3.5" />
                        <div className="flex items-center justify-between gap-3">
                          <div className="flex flex-col">
                            <span className="text-[9px] uppercase font-jost text-[#2D1F18]/40 leading-none">Valuation</span>
                            <span className="font-poppins font-bold text-[#2D1F18] text-base mt-0.5">₹{salePrice}</span>
                          </div>

                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleAddToWishList(item.product_id)}
                              className="w-8 h-8 rounded-full border border-[#C5A880]/20 flex items-center justify-center text-[#2D1F18]/60 hover:text-[#db0f0f] hover:bg-white transition-all cursor-pointer bg-white"
                              aria-label="Save to wishlist"
                            >
                              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                              </svg>
                            </button>

                            <button
                              onClick={() => handleAddCart(item.product_id)}
                              className="bg-[#2D1F18] hover:bg-[#C5A880] text-white hover:text-[#2D1F18] font-jost text-xs font-semibold px-4 py-2 rounded-xl flex items-center gap-1.5 transition-all shadow-sm cursor-pointer border border-[#2D1F18] hover:border-[#C5A880]"
                            >
                              <i className="fi-rs-shopping-cart" />
                              <span>Acquire</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <p className="mt-4 text-center font-jost text-sm text-[#2D1F18]/60">
              Stay ahead of the curve with our daily dose of inspiration. Shop today's must-have products and discover new favorites that reflect your unique style and interests.
            </p>
          </div>
        </div>
      </main>
      <ToastContainer/>
    </>
  );
}

export default Page2;
